import { LandingUrl } from 'src/core/domain/LandingUrl';

export const redirectToRemoveToken = () => {
  window.location.href = `${LandingUrl}/remove-token`;
};

export const redirectToLanding = () => {
  window.location.href = LandingUrl;
};
